export class NewAccountRegisterResult {
  isOk: boolean;
  isExpired: boolean;
  isAlreadyRegistered: boolean;
}
